<div>

  <h1>Help Pages & Guides</h1>

  <mbnm-navigation-tiles [tileCollection]="tiles" [enableHero]="false" linkStyle="text">

  </mbnm-navigation-tiles>

  @if (!tiles) {
    <mat-spinner color="secondary"></mat-spinner>
  }
</div>
